import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { IconButton, Tooltip } from "@material-ui/core";
import Icon from "@jll/icon";
import AddIcon from "@material-ui/icons/Add";

import styles from "./styles";
import { formatDate } from "../../../../../../Utilities/Functions";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../../../Component/Table/tableCommonStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const RulesTable = ({
  data,
  onView,
  onDelete,
  onAdd,
  canAddRule,
  canUpdateRule,
  canRemoveRule,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        style={tableStyle}
        icons={tableIcons}
        title={t("labels.accessControl.table.header")}
        options={{ ...tableOptions, toolbar: true, sorting: true }}
        isLoading={false}
        data={data}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
          },
        }}
        columns={[
          {
            title: t("labels.accessControl.table.headers.name"),
            field: "name",
          },
          {
            title: t("labels.accessControl.table.headers.description"),
            field: "description",
          },
          {
            title: t("labels.accessControl.table.headers.lastUpdated"),
            field: "lastModifiedDate",
            render: (rowData) => {
              return <span>{formatDate(rowData.lastModifiedDate, true)}</span>;
            },
          },
          {
            title: t("labels.accessControl.table.headers.lastUpdatedBy"),
            field: "lastModifiedByUsername",
          },
        ]}
        actions={[
          {
            icon: "AddRule",
            tooltip: t("labels.common.add"),
            isFreeAction: true,
            onClick: (rule) => onAdd(rule),
          },
          {
            icon: "ViewColumn",
            tooltip: t("labels.common.view"),
            onClick: (rule) => onView(rule),
          },
          {
            icon: "DeleteColumn",
            tooltip: t("labels.common.remove"),
            onClick: (rule) => onDelete(rule),
          },
        ]}
        components={{
          Action: (props) => {
            switch (props.action.icon) {
              case "ViewColumn":
                return (
                  <Tooltip title={t("labels.common.view")} placement="bottom">
                    <IconButton
                      className={classes.actionIcons}
                      onClick={(event) => props.action.onClick(props.data)}
                    >
                      <Icon
                        className="fas fa-address-card"
                        style={{ fontSize: 16 }}
                      />
                    </IconButton>
                  </Tooltip>
                );
              case "AddRule":
                if (canAddRule) {
                  return (
                    <Tooltip title={t("labels.common.add")} placement="bottom">
                      <IconButton
                        className={classes.actionIcons}
                        onClick={() => props.action.onClick()}
                        style={{ marginRight: "1rem" }}
                      >
                        <AddIcon fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  );
                }
              case "DeleteColumn":
                if (canRemoveRule && props.data.id !== "2") {
                  return (
                    <Tooltip
                      title={t("labels.common.remove")}
                      placement="bottom"
                    >
                      <div>
                        <IconButton
                          className={classes.actionIcons}
                          onClick={(event) => props.action.onClick(props.data)}
                        >
                          <Icon
                            className="far fa-trash-alt"
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>
                  );
                } else {
                  return null;
                }

              default:
                return null;
            }
          },
        }}
      />
    </div>
  );
};

export default React.memo(RulesTable);
